<template>
  <div class="textPage">
    <a
      class="textBox"
      :class="{ textBox__paddingTop: index > 0 }"
      v-for="(item, index) in data"
      :key="index"
      @click="chooseItem(index)"
    >
      <div class="title">{{ item.title }}</div>
      <div class="time">{{ item.publishTime }}</div>
    </a>
  </div>
</template>

<script>
export default {
  name: "CellText",
  props: ["data"],
  methods: {
    chooseItem(index) {
      console.log(111222);
      this.$emit("chooseItem", index);
    }
  }
};
</script>
<style scoped>
.textBox {
  border-bottom: 1px solid rgba(231, 231, 231, 1);
  font-size: 18px;
  padding:20px 10px 20px 10px;
  /*line-height: 48px;*/
}
.textBox .title{
  font-size: 16px;
  line-height: 24px;
}
.textBox .time{
  font-size: 14px;
  color: #b1b1b1;
}
.textBox:hover {
  background-color: #f1f5f7;
}
.textBox__paddingTop {
  padding-top: 22px;
}
</style>
